import { Capacitor } from '@capacitor/core'

let keycloakInstance = null

export function setKeycloakInstance(keycloak) {
  keycloakInstance = keycloak
}

export function getLogoutRedirectUri() {
  if (Capacitor.isNativePlatform()) {
    return 'com.lexxy.app://'
  }

  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return `${window.location.origin}/`
  }

  return process.env.VUE_APP_URL
}

export function buildKeycloakLogoutUrl({
  ssoUrl = process.env.VUE_APP_SSO_URL,
  realm = process.env.VUE_APP_SSO_REALM,
  redirectUri,
  idToken,
  clientId
} = {}) {
  const base = `${String(ssoUrl || '').replace(/\/$/, '')}/realms/${realm}/protocol/openid-connect/logout`
  const url = new URL(base)

  if (redirectUri) {
    url.searchParams.set('post_logout_redirect_uri', redirectUri)
  }
  if (idToken) {
    url.searchParams.set('id_token_hint', idToken)
  }
  if (clientId) {
    url.searchParams.set('client_id', clientId)
  }

  return url.toString()
}

export function logoutKeycloak(idToken) {
  const redirectUri = getLogoutRedirectUri()

  if (keycloakInstance && typeof keycloakInstance.logout === 'function') {
    keycloakInstance.logout({ redirectUri })
    return
  }

  const clientId = typeof window !== 'undefined'
    ? window.location.host.replace(/:.*/, '')
    : process.env.VUE_APP_SSO_CLIENT

  window.location.href = buildKeycloakLogoutUrl({
    redirectUri,
    idToken,
    clientId
  })
}
